/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import styles from '../../styles/general.module.scss';
import Styles from './list.module.scss';

const Table = ({ info, handleDropDown, gateDropdown, popupId, handleEdit, handleDays }) => (
  <table className={styles.table} style={{ tableLayout: 'fixed' }}>
    <thead>
      <tr>
        <th className={styles.invoiceid} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="SCHEDULE TYPE" defaultMessage="SCHEDULE TYPE" />
        </th>
        <th className={styles.createdby} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="GATE" defaultMessage="GATE #" />
        </th>
        <th className={styles.createdby} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="TAIL" defaultMessage="TAIL #" />
        </th>
        <th className={styles.invoicedate} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="FLIGHT" defaultMessage="ARRIVAL FLIGHT #" />
        </th>
        <th className={styles.invoicedate} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="FLIGHT" defaultMessage="DEPARTURE FLIGHT #" />
        </th>
        <th className={styles.companyname} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="AIRLINE" defaultMessage="AIRLINE NAME" />
        </th>
        <th className={styles.invoiceamount} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="ARRIVAL CITY" defaultMessage="ARRIVAL FROM" />
        </th>
        <th className={styles.invoiceamount} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="DEPARTURE CITY" defaultMessage="DEPARTURE TO" />
        </th>
        <th className={styles.invoicestatus} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="SCHEDULED TIME OF ARRIVAL (STA)" defaultMessage="SCHEDULED TIME OF ARRIVAL (STA)" />
        </th>
        <th className={styles.invoicestatus} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="SCHEDULED TIME OF DEPARTURE (STD)" defaultMessage="SCHEDULED TIME OF DEPARTURE (STD)" />
        </th>
        <th className={styles.invoicestatus} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="AIRCRAFT TYPE" defaultMessage="AIRCRAFT TYPE" />
        </th>
        <th className={styles.invoicestatus} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="DAYS OF OPERATION" defaultMessage="DAYS OF OPERATION" />
        </th>
        <th className={styles.invoicestatus} style={{ lineHeight: '20px', padding: '14px 20px' }}>
          <FormattedMessage id="OVERNIGHT" defaultMessage="OVERNIGHT" />
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      {!info.length > 0 ? (
        <tr>
          <td className="noTableData" colSpan={14}>
            <FormattedMessage id="gate.list.table.no_results" defaultMessage="There is no plan data." />
          </td>
        </tr>
      )
        : (
          info?.map(e => (
            <tr key={e.id}>
              <td>{e?.schedule_type}</td>
              <td>{e?.gate_key}</td>
              <td>{e?.tail_number}</td>
              <td>{e?.arrival_flight_number}</td>
              <td>{e?.departure_flight_number}</td>
              <td>{e?.airline}</td>
              <td>{e?.from_city_icao}</td>
              <td>{e?.to_city_icao}</td>
              <td>{(e?.schedule_arrival && moment.utc(e?.schedule_arrival, 'HH:mm').format('hh:mm A'))}</td>
              <td>{(e?.schedule_departure && moment.utc(e?.schedule_departure, 'HH:mm').format('hh:mm A'))}</td>
              <td>{e?.aircraft_type}</td>
              <td>{handleDays(e?.operation_days)}</td>
              <td>{e?.over_night && e?.over_night==='N' ? 'NO' : 'YES'}</td>
              <td>
                <div>
                  <span
                    className={Styles.meetingEdit}
                    onClick={() => handleDropDown(e.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <FormattedMessage
                      id="workorders.detail.actionBtn"
                      defaultMessage="Actions"
                    />
                  </span>
                  {gateDropdown && (popupId===e.id) && (
                    <ul className={`${Styles.actionpopup} ${gateDropdown ? Styles.open : ''}`}>
                      <li className={Styles.item}>
                        <span
                          onClick={() => handleEdit(e.id)}
                        >
                          <FormattedMessage
                            id="sms.meeting.edit"
                            defaultMessage="Edit"
                          />
                        </span>
                      </li>
                    </ul>
                  )}
                </div>
              </td>
            </tr>
          ))
        )
        }
    </tbody>
  </table>
);

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Table;
